<div class="contract-terminate-container" fxLayout="column" fxLayoutGap="15px" [formGroup]="terminateForm">
  <div fxLayout="row">
    <h3>Rozwiąż umowę</h3>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Powód rozwiązania</mat-label>
      <textarea formControlName="terminationReason" matInput placeholder="Powód rozwiązania"></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100">
      <mat-slide-toggle *ngIf="![
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_LEAD,
  CONTRACT_TYPE_LEASING,
  CONTRACT_TYPE_TERMINAL
  ].includes(contractObject?.type?.key)" color="accent" formControlName="reassignOfwca">Czy OFWCA i/lub rejestracje podpięte pod tą umową powinny zostać przypięte na innego Partnera/umowę?</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row" *ngIf="terminateForm.get('reassignOfwca').value">
    <app-ofwca-to-reassign-list fxFlex="100" [contract]="contract" [disableModificationSwitch]="true"></app-ofwca-to-reassign-list>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="terminate()" [class.spinner]="processingRequest" [disabled]="processingRequest || !terminateForm.valid"
            mat-stroked-button color="primary"><mat-icon>content_paste_off</mat-icon> <span> Rozwiąż</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
